import path from "path";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ShareAffiliateModal from "./ShareAffiliateModal";

const AffiliateHeader = () => {
  const [open, setOpen] = useState(false);
  const tabsContainerRef = useRef(null);
  const pathname = window.location.pathname;
  const checkSelectedTab = (name) => name == pathname;
  const tabs = [
    { id: 1, path: "/affiliate", name: "Dashboard" },
    { id: 2, path: "/affiliate/user-list", name: "User List" },
    { id: 3, path: "#", name: "Share Affiliate" },
    { id: 4, path: "/affiliate/user-profit-loss", name: "User Profit/Loss" },
    { id: 5, path: "/affiliate/report", name: "Report" },
  ];

  const navigate = useNavigate();
  return (
    <>
      <ShareAffiliateModal setOpen={setOpen} open={open} />
      <div className="flex items-center hidden lg:flex  justify-between w-full overflow-x-auto  gap-[3px]  no-scrollbar mt-2 text-center ">
        <div ref={tabsContainerRef} className=" flex gap-[6px]">
          {tabs.map((item) => {
            return (
              <button
                key={item?.id}
                className={`inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out ${
                  checkSelectedTab(item?.path)
                    ? "bg-bg_text_brand_primary-mar text-white"
                    : "bg-bg_Quaternary"
                } px-4 py-2 flex items-center justify-center border  rounded-full text-text_Quaternary whitespace-nowrap uppercase font-lato font-[700] text-xs  cursor-pointer`}
                type="button"
                data-tab={`${item.path}`}
                onClick={() => {
                  if (item.path === "#") {
                    setOpen(!open);
                  } else {
                    navigate(item.path);
                  }
                }}
              >
                <span
                  className={
                    checkSelectedTab(item?.path)
                      ? "text-white"
                      : "text-text_Ternary"
                  }
                >
                  {item?.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default AffiliateHeader;
